import PatternRulesList from 'templates/presentation/components/organisms/PatternRulesList/PatternRulesList'

import React from 'react'
import { useParams } from 'react-router-dom'

export default function PatternDetailsPage() {
    const { patternId } = useParams()
    const patternIdNumber = Number(patternId)

    return (
        <div>
            <PatternRulesList pattern={patternIdNumber} />
        </div>
    )
}
